import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import logger from 'redux-logger'

import createHistory from 'history/createBrowserHistory'

import { routerMiddleware } from 'react-router-redux'
import reducers from './reducers'
import Layout from './components/Layout'

export const history = createHistory()

const store = createStore(
  reducers,
  applyMiddleware(logger, thunk, routerMiddleware(history)),
);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Layout />
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js